"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iLatestFileEvents = exports.iEventData = exports.iFileEventResponseData = exports.iProjectEventResponse = exports.iFileEventResponse = exports.iProjectEvent = exports.iFileEvent = exports.iCommonEvent = exports.iFileEventTypes = exports.iProjectEventTypes = void 0;
const t = require("io-ts");
const File = require("./file");
const User = require("./user");
const Project = require("./project");
const Date = require("./date");
exports.iProjectEventTypes = t.literal('UpdateProjectMetadataEvent');
exports.iFileEventTypes = t.union([
    t.literal('CreateFileEvent'),
    t.literal('FileBookmarkedEvent'),
    t.literal('FileDownloadedEvent'),
    t.literal('FilePreviewEvent'),
    t.literal('FileDeletedEvent')
]);
exports.iCommonEvent = t.interface({
    timestamp: Date.iDateFromString,
    mongoId: t.string,
    id: t.number
});
exports.iFileEvent = t.intersection([
    exports.iCommonEvent,
    t.interface({
        type: exports.iFileEventTypes
    })
]);
exports.iProjectEvent = t.intersection([
    exports.iCommonEvent,
    t.interface({
        projectId: t.number,
        type: exports.iProjectEventTypes
    })
]);
exports.iFileEventResponse = t.interface({
    event: exports.iFileEvent,
    revisions: t.array(File.iRevision),
    user: User.iAuthor
});
exports.iProjectEventResponse = t.interface({
    event: exports.iProjectEvent,
    project: Project.iProject,
    user: User.iAuthor
});
exports.iFileEventResponseData = t.interface({
    events: t.array(exports.iFileEventResponse),
    numberOfEvents: t.number
});
exports.iEventData = t.interface({
    name: t.string,
    file: t.number,
    project: t.number,
    type: t.string
});
exports.iLatestFileEvents = t.interface({
    email: t.string,
    firstName: t.string,
    lastName: t.string,
    events: t.array(exports.iEventData)
});
//# sourceMappingURL=fileActivity.js.map